import React, { useEffect, useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { Button } from './ui/Button';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 50);
  });
  const navLinks = [{
    name: 'Overview',
    href: '#overview'
  }, {
    name: 'Garage',
    href: '#garage'
  }, {
    name: 'Lifestyle',
    href: '#lifestyle'
  }, {
    name: 'Location',
    href: '#location'
  }];
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#FAF8F5]/95 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-4'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="flex justify-between items-center" data-id="element-145">
          {/* Logo Section */}
          <div className="flex items-center space-x-6" data-id="element-146">
            <img src="https://cdn.magicpatterns.com/uploads/uYeQcMN2WEdQfvg6dSbtb3/HOMESMARTNEXT.png" alt="HomeSmart Next" className={`transition-all duration-300 ${isScrolled ? 'h-8' : 'h-10'}`} data-id="element-147" />
            <div className={`hidden sm:block h-8 w-px ${isScrolled ? 'bg-gray-300' : 'bg-white/30'}`} data-id="element-148"></div>
            <a href="#" className={`font-serif text-xl sm:text-2xl font-bold tracking-tight ${isScrolled ? 'text-[#2D2D2D]' : 'text-white'}`} data-id="element-149">
              DESERT HILLS{' '}
              <span className="font-light hidden sm:inline" data-id="element-150">ESTATE</span>
            </a>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-151">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium tracking-wide transition-colors ${isScrolled ? 'text-[#2D2D2D] hover:text-[#C1694F]' : 'text-white/90 hover:text-white'}`} data-id="element-152">
                {link.name.toUpperCase()}
              </a>)}
            <a href="https://calendar.app.google/wrWsFckucxpttSGB6" target="_blank" rel="noopener noreferrer" data-id="element-153">
              <Button variant={isScrolled ? 'primary' : 'white'} size="sm" data-id="element-154">
                Tour
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-155">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={`p-2 rounded-md ${isScrolled ? 'text-[#2D2D2D]' : 'text-white'}`} data-id="element-156">
              {isMobileMenuOpen ? <X size={24} data-id="element-157" /> : <Menu size={24} data-id="element-158" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} className="md:hidden bg-[#FAF8F5] border-t border-gray-100" data-id="element-159">
          <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-160">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-[#2D2D2D] hover:bg-gray-50 hover:text-[#C1694F]" onClick={() => setIsMobileMenuOpen(false)} data-id="element-161">
                {link.name}
              </a>)}
            <div className="pt-4" data-id="element-162">
              <a href="https://calendar.app.google/wrWsFckucxpttSGB6" target="_blank" rel="noopener noreferrer" className="block" data-id="element-163">
                <Button className="w-full" data-id="element-164">Tour</Button>
              </a>
            </div>
          </div>
        </motion.div>}
    </motion.nav>;
}